export const REPORTUNDECLAREDHOURS_SEARCH = 'REPORTUNDECLAREDHOURS_SEARCH';
export const REPORTUNDECLAREDHOURS_PAGE = 'REPORTUNDECLAREDHOURS_PAGE';
export const REPORTUNDECLAREDHOURS_YEAR = 'REPORTUNDECLAREDHOURS_YEAR';
export const REPORTUNDECLAREDHOURS_WORKTYPE = 'REPORTUNDECLAREDHOURS_WORKTYPE';
export const REPORTUNDECLAREDHOURS_USERID = 'REPORTUNDECLAREDHOURS_USERID';